module.exports = __webpack_public_path__ + "static/media/icon.d4310807.svg";